import { render } from "./DashboardUser.vue?vue&type=template&id=144c678a&scoped=true"
import script from "./DashboardUser.vue?vue&type=script&lang=js"
export * from "./DashboardUser.vue?vue&type=script&lang=js"

import "./DashboardUser.vue?vue&type=style&index=0&id=144c678a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-144c678a"]])

export default __exports__